const ViewState = {
    focusedSurface: null,
    colorlist: [
        "red", "green", "blue", "yellow", "cyan", "magenta"
    ]
}



export default ViewState